module.exports = __webpack_public_path__ + "img/mirror19.391a9e83.jpg";